<template>
<main v-if="!loading">
  <div class="container">
    <h3>Table of Subject</h3>
    <hr />
    <table class="table table-hover table-responsive table-striped">
      <thead class="thead thead-dark">
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Slug</th>
          <th>Published</th>
          <th>Action</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody class="shadow-lg">
        <tr v-for="subject in subjects" :key="subject.id">
          <th scope="row">{{ subject.id }}</th>
          <td>
            <router-link
              :to="{
                name: 'subjects.show',
                params: { id: subject.id },
              }"
              >{{ subject.name }}</router-link
            >
          </td>
          <td>{{ subject.slug }}</td>
          <td>{{ subject.published }}</td>
          <td>
            <router-link
              :to="{
                name: 'subjects.edit',
                params: { id: subject.id },
              }"
              class="badge badge-warning">Edit</router-link
            >
          </td>
          <td>
            <delete-subject :endpoint="subject.id" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </main>

 <main class="container" v-else>
    <p class="h1">
      Mengambil Data..
    </p>
    <img :src="loadingImage" class="rounded float-left" alt="" />
  </main>
</template>

<script>
import axios from "axios";
import DeleteSubject from "./Delete";
export default {
  components: {
    DeleteSubject,
  },
  data() {
    return {
      loading: true,
      subjects: [],
      loadingImage: require("@/assets/loading.svg"),
    };
  },

  mounted() {
    // axios.get("/api/notes").then(response => {
    //     this.notes = response.data.data;
    //     // console.log(response.data.data);
    // });
    this.getSubjects();
  },

  methods: {
    async getSubjects() {
       this.loading = true;
      // let response = await await axios.get("/api/notes");
      // this.notes = response.data.data;
      let { data } = await await axios.get("/api/subjects/table");
      this.subjects = data.data;
       this.loading = false;
    },
  },
};
</script>
